import {BrowserRouter, Link, NavLink, Route, Routes} from 'react-router-dom';
import {ErrorBoundary} from 'react-error-boundary';
import React, {useEffect, useState} from 'react';
import Home from './components/Home';
import Login from './components/SignIn';
import SignUp from './components/SignUp';
import Vocabulary from './components/Vocabulary';
import Grammar from './components/Grammar';
import Writing from './components/Writing';
import Translating from './components/Translating';
import Conversation from './components/Conversation';
import Speaking from './components/Speaking';
import User from './components/User';
import './App.css';
import 'materialize-css/dist/css/materialize.min.css';

const navigation = [
  {to: '/', label: 'Home', icon: 'home', end: true},
  {to: '/vocabulary', label: 'Vocabulary', icon: 'translate'},
  {to: '/grammar', label: 'Grammar', icon: 'menu_book'},
  {to: '/writing', label: 'Writing', icon: 'edit_note'},
  {to: '/speaking', label: 'Speaking', icon: 'record_voice_over'}
];

function Notification({message, onClose}) {
  useEffect(() => {
    const timer = window.setTimeout(onClose, 5000);
    return () => window.clearTimeout(timer);
  }, [onClose]);

  return <div className="notification" role="alert">{message}</div>;
}

function SafePracticeRoute({children}) {
  return <ErrorBoundary fallback={<div className="page-loader">This exercise could not be opened. Refresh and try again.</div>}>
    {children}
  </ErrorBoundary>;
}

function App() {
  const [notification, setNotification] = useState(null);
  const showNotification = (message) => setNotification(message);
  const hideNotification = () => setNotification(null);

  return (
    <div className="App">
      <BrowserRouter>
        <div className="app-shell">
          <header className="app-header">
            <nav className="app-nav" aria-label="Main navigation">
              <Link to="/" className="brand" aria-label="anglisik home">
                <span className="brand-mark" aria-hidden="true">a</span>
                anglisik
              </Link>
              <div className="app-nav__links">
                {navigation.map(({to, label, icon, end}) => (
                    <NavLink key={to} to={to} end={end} className={({isActive}) => `app-nav__link${isActive ? ' active' : ''}`}>
                      <i className="material-icons" aria-hidden="true">{icon}</i><span>{label}</span>
                    </NavLink>
                ))}
              </div>
              <NavLink to="/user" className={({isActive}) => `app-nav__profile${isActive ? ' active' : ''}`} aria-label="Profile">
                <i className="material-icons" aria-hidden="true">person</i>
              </NavLink>
            </nav>
          </header>

          {notification && <Notification message={notification} onClose={hideNotification}/>}
          <Routes>
            <Route path="/" element={<Home showNotification={showNotification}/>}/>
            <Route path="/login" element={<Login showNotification={showNotification}/>}/>
            <Route path="/user" element={<User showNotification={showNotification}/>}/>
            <Route path="/sign-up" element={<SignUp showNotification={showNotification}/>}/>
            <Route path="/vocabulary" element={<SafePracticeRoute><Vocabulary showNotification={showNotification}/></SafePracticeRoute>}/>
            <Route path="/writing" element={<Writing showNotification={showNotification}/>}/>
            <Route path="/conversation" element={<Conversation showNotification={showNotification}/>}/>
            <Route path="/translating" element={<Translating showNotification={showNotification}/>}/>
            <Route path="/speaking" element={<SafePracticeRoute><Speaking showNotification={showNotification}/></SafePracticeRoute>}/>
            <Route path="/grammar" element={<Grammar showNotification={showNotification}/>}/>
          </Routes>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
